export const getCurrentLocation = () =>
  new Promise((resolve) => {
    try {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            resolve({ lat: pos.coords.latitude, long: pos.coords.longitude });
          },
          (err) => {
            console.error(
              new Error(`Geo-Location Error(${err.code}): ${err.message}`)
            );
            resolve({ lat: null, long: null });
          },
          { enableHighAccuracy: true, maximumAge: 5000, timeout: 15000 }
        );
      } else throw new Error("Geo-Location APIs are unavailable");
    } catch (err) {
      console.error(err);
      resolve({ lat: null, long: null });
    }
  });
